import { Box, Card, CardContent, Grid } from "@mui/material";
import { AutoCompleteEirCode } from "@features/eircode/AutoCompleteEircode/AutoCompleteEirCode";
import { Error } from "@common/HandleErrorAndLoading/Error";
import { usePrequal } from "@features/prequal/usePrequal";
import { IEirSalesPrequal } from "@modules/eirSalesFacade/interfaces/models/IEirSalesPrequal";
import { useTranslation } from "react-i18next";
import { useStyle } from "./style";
import { LabeledButton } from "@common/LabeledButton/LabeledButton";
import { BUTTON_IDS } from "@features/dataLayer/buttonIds";
import { MutableRefObject } from "react";

interface IParams {
    eirCodeFieldRef?: MutableRefObject<HTMLInputElement | null>;
    isSidePanel?: boolean;
    isWrapped?: boolean;
    setPrequal(prequal: IEirSalesPrequal): void;
}

export const Prequal = (props: IParams) => {
    const { eirCodeFieldRef, isSidePanel, isWrapped, setPrequal } = props;
    const { t } = useTranslation("home");
    const { classes } = useStyle();

    const { formMethods, getPrequalAddress, prequalAddress, isLoading, error, submitPrequalAddress } = usePrequal({
        setPrequal,
    });

    return (
        <Card className={classes.card} elevation={2}>
            <CardContent>
                <Grid columnSpacing={1} container>
                    <Grid item xs={isWrapped ? 12 : 8}>
                        <AutoCompleteEirCode
                            addressForm={formMethods}
                            getSelectedAddress={getPrequalAddress}
                            inputRef={eirCodeFieldRef}
                        />
                    </Grid>
                    <Grid item marginBottom={isWrapped ? 1 : 2} marginTop={isWrapped ? 0 : 1.4} xs={isWrapped ? 12 : 4}>
                        <LabeledButton
                            className={classes.canGetBroadbandButton}
                            color="primary"
                            disabled={isLoading}
                            id={
                                isSidePanel
                                    ? BUTTON_IDS.MOBILE_FLOW.DRAWER_CTA.CAN_I_GET_BROADBAND
                                    : BUTTON_IDS.BROADBAND_FLOW.PAGE_CTA.CAN_I_GET_GOMO_BROADBAND
                            }
                            labelText={t("canGetBroadband")}
                            onClick={() => submitPrequalAddress(prequalAddress)}
                        >
                            {t("canGetBroadband")}
                        </LabeledButton>
                    </Grid>
                </Grid>
                {error && (
                    <Box paddingTop={4}>
                        <Error error={error} />
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};
